import { api } from 'app/config/apiConfig';
import { Box, CreateBoxParams } from '../model/types';

export const createBoxApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createBox: builder.mutation<Box, CreateBoxParams>({
      query: (data) => ({
        url: '/boxes',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Boxes', 'Warehouses for booking'],
    }),
  }),
});

export const { useCreateBoxMutation } = createBoxApi;
